import { Link, useHistory, useLocation } from "react-router-dom";
import "./../reports/report-nav.css";
import { BsCollection } from "react-icons/bs";
import { VscActivateBreakpoints } from "react-icons/vsc";
import { useState, useEffect } from "react";
import arrowdown from "../assets/images/arrow-down.svg";
import arrowdownblack from "../assets/images/arrow-down-black.svg";
import { storage } from "../utils/storage";
import { ImPointDown } from "react-icons/im";

const ReportNav = () => {
  const history = useHistory();
  const location = useLocation();
  const url = location.pathname;

  const [open, setOpen] = useState(true);
  const [reportdrop, setReportdrop] = useState(
    () =>
      url === "/reports" ||
      url.includes("/my-reports") ||
      url.includes("predue") ||
      url.includes("postgreater") ||
      url.includes("postless") ||
      url.includes("latedue"),
  );
  const [standardReportDrop, setStandardReportDrop] = useState(
    () =>
      url.includes("predue") ||
      url.includes("postgreater") ||
      url.includes("postless") ||
      url.includes("latedue"),
  );

  const [openaudit, setOpenaudit] = useState(false);
  const [intentDrop, setIntentDrop] = useState(
    () =>
      url.includes("/reports/customer-intent") ||
      url.includes("/reports/product-intent") ||
      url.includes("/reports/ptp"),
  );

  const client = storage.getItem("client");
  const usecase = storage.getItem("usecase");
  const role = storage.getItem("role");
  const collectionModule = storage.getItem("collection_module") === "true";
  const stockBrokingModule = storage.getItem("stock_broking_module") === "true";

  const isStandardReportActive =
    url.includes("predue") ||
    url.includes("postgreater") ||
    url.includes("postless") ||
    url.includes("latedue");

  useEffect(() => {
    setOpenaudit(
      url.includes("criticalBusiness") ||
        url.includes("criticalcustomer") ||
        url.includes("criticalregulatory") ||
        url.includes("noncritical"),
    );
  }, [url]);

  useEffect(() => {
    if (isStandardReportActive) {
      setReportdrop(true);
      setStandardReportDrop(true);
    } else if (url.includes("my-reports")) {
      setReportdrop(true);
      setStandardReportDrop(false);
    } else if (url === "/reports") {
      setReportdrop(true);
      setStandardReportDrop(false);
    } else {
      setReportdrop(false);
      setStandardReportDrop(false);
    }
  }, [url, isStandardReportActive]);

  const handleMyReportsClick = () => {
    setStandardReportDrop(false);
    setReportdrop(true);
    history.push("/reports/my-reports");
  };

  const handleCollectionStrategy = () => {
    setReportdrop(true);
    history.push("/reports/collection-strategy");
  };

  const handleTranscriptionAudit = () => {
    setReportdrop(true);
    history.push("/reports/transcription-report");
  };

  // Trade Section for DBS Bank Singapore
  const renderTradeSection = () => (
    <ul>
      <li
        className="list-none"
        style={{ marginLeft: "30px", display: "flex", alignItems: "center" }}
        onClick={() => setOpen(!open)}
      >
        <i
          className={`${
            !open ? "fa fa-arrow-right" : "fa fa-arrow-right click"
          } text-3xl`}
          aria-hidden="true"
        ></i>
        <a style={{ fontSize: "16px", fontWeight: "bold" }}>Trade</a>
      </li>
      {open && (
        <ul
          style={{
            marginLeft: "20px",
            transition: "ease-in",
            marginTop: "15px",
          }}
        >
          <li className={url === "/reports/forex" ? "active" : ""}>
            <Link to="/reports/forex">
              <i className="fa fa-money" aria-hidden="true"></i>
              <a style={{ fontSize: "14px" }}>Forex</a>
            </Link>
          </li>
          <li className={url === "/reports/equity" ? "active" : "disabled"}>
            <Link to="/reports/equity">
              <i className="fa fa-line-chart" aria-hidden="true"></i>
              <a style={{ fontSize: "14px" }}>Equity</a>
            </Link>
          </li>
          <li className={url === "/reports/mutual" ? "active" : "disabled"}>
            <Link to="/reports/mutual">
              <i className="fa fa-users" aria-hidden="true"></i>
              <a style={{ fontSize: "14px" }}>Mutual Funds</a>
            </Link>
          </li>
        </ul>
      )}
      {role === "Master" && (
        <li className={url === "/reports/agent-scorecard" ? "active" : ""}>
          <Link to="/reports/agent-scorecard">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-journal-text"
              viewBox="0 0 16 16"
            >
              <path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5" />
              <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" />
              <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" />
            </svg>
            <a style={{ fontSize: "16px", fontWeight: "bold" }}>
              Agent Scorecard
            </a>
          </Link>
        </li>
      )}
    </ul>
  );

  // Complaints Management Section
  const renderComplaintsManagement = () => (
    <ul>
      <li className={url === "/reports/service-request" ? "active" : ""}>
        <Link to="/reports/service-request">
          <i className="fa fa-superpowers" aria-hidden="true"></i>
          <a style={{ fontSize: "14px" }}>Incoming Complaints</a>
        </Link>
      </li>
      <li className={url === "/reports/customer-intent" ? "active" : ""}>
        <Link to="/reports/customer-intent">
          <i className="fa fa-tachometer" aria-hidden="true"></i>
          <a style={{ fontSize: "14px" }}>Intent Trend</a>
        </Link>
      </li>
      <li className={url === "/reports/product-intent" ? "active" : ""}>
        <Link to="/reports/product-intent">
          <i className="flaticon-analytics"></i>
          <a style={{ fontSize: "14px" }}>Sentiments Trends</a>
        </Link>
      </li>
      <li className={url === "/reports/cx-score-trend" ? "active" : ""}>
        <Link to="/reports/cx-score-trend">
          <i className="fa fa-line-chart" aria-hidden="true"></i>
          <a style={{ fontSize: "14px" }}>Complaints Intent Trends</a>
        </Link>
      </li>
      <li className={url === "/reports/manager-review" ? "active" : ""}>
        <Link to="/reports/manager-review">
          <i className="fa fa-comment" aria-hidden="true"></i>
          <a style={{ fontSize: "14px" }}>Manager Review</a>
        </Link>
      </li>
      <li className={url === "/reports/opportunity" ? "active" : ""}>
        <Link to="#">
          <i className="fa fa-snowflake-o" aria-hidden="true"></i>
          <a style={{ fontSize: "14px" }}>Reopened by DataKlout</a>
        </Link>
      </li>
      {collectionModule && (
        <li className={url === "/reports/collection" ? "active" : ""}>
          <Link to="#">
            <span className="flex items-center">
              <BsCollection />
              <a style={{ fontSize: "14px" }}>Customer Survey</a>
            </span>
          </Link>
        </li>
      )}
      <li className={url === "/reports/performance" ? "active" : ""}>
        <Link to="#">
          <span className="flex items-center">
            <VscActivateBreakpoints />
            <a style={{ fontSize: "14px" }}>Outlier Case Analysis</a>
          </span>
        </Link>
      </li>
      {stockBrokingModule && (
        <li className={url === "/reports/compliance" ? "active" : ""}>
          <Link to="/reports/compliance">
            <VscActivateBreakpoints />
            <a style={{ fontSize: "14px" }}>Compliance</a>
          </Link>
        </li>
      )}
    </ul>
  );

  // Insurance PCVC Verification Section
  const renderInsurancePCVC = () => (
    <div>
      <span
        className={`flex items-center sec-c flex-row ${
          url === "/reports/dashboard" ? "active" : ""
        }`}
      >
        <Link to="/reports/dashboard" className="flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill={url === "/reports/dashboard" ? "white" : "black"}
            className="bi bi-card-checklist"
            viewBox="0 0 16 16"
          >
            <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z" />
            <path d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0M7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0" />
          </svg>
          <span
            className={`font-medium ml-6 ${
              url === "/reports/dashboard" ? "text-white" : "text-black"
            }`}
            style={{ fontSize: "16px" }}
          >
            Dashboard
          </span>
        </Link>
      </span>
      <div className="flex flex-col mt-2">
        <span
          className={`flex items-center sec-c cursor-pointer`}
          onClick={() => setOpenaudit(true)}
        >
          <i
            className={`opacity-70 ${
              !openaudit ? "fa fa-arrow-right" : "fa fa-arrow-right click"
            }`}
            aria-hidden="true"
          ></i>
          <span
            className="font-medium ml-6 text-black"
            style={{ fontSize: "16px" }}
          >
            Audit
          </span>
        </span>
        {openaudit && (
          <div className="flex py- px-8 flex-col">
            <span
              className={`flex items-center sec-c ${
                url === "/reports/criticalBusiness" ? "active" : ""
              }`}
            >
              <i className="fa fa-snowflake-o" aria-hidden="true"></i>
              <Link to="/reports/criticalBusiness">
                <span
                  className={`font-medium ml-6 ${
                    url === "/reports/criticalBusiness"
                      ? "text-white"
                      : "text-black"
                  }`}
                  style={{ fontSize: "16px" }}
                >
                  Business
                </span>
              </Link>
            </span>
            <span
              className={`flex items-center sec-c ${
                url === "/reports/criticalcustomer" ? "active" : ""
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-person"
                viewBox="0 0 16 16"
              >
                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
              </svg>
              <Link to="/reports/criticalcustomer">
                <span
                  className={`font-medium ml-6 ${
                    url === "/reports/criticalcustomer"
                      ? "text-white"
                      : "text-black"
                  }`}
                  style={{ fontSize: "16px" }}
                >
                  Customer
                </span>
              </Link>
            </span>
            <span
              className={`flex items-center sec-c ${
                url === "/reports/criticalregulatory" ? "active" : ""
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-file-ruled"
                viewBox="0 0 16 16"
              >
                <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v4h10V2a1 1 0 0 0-1-1zm9 6H6v2h7zm0 3H6v2h7zm0 3H6v2h6a1 1 0 0 0 1-1zm-8 2v-2H3v1a1 1 0 0 0 1 1zm-2-3h2v-2H3zm0-3h2V7H3z" />
              </svg>
              <Link to="/reports/criticalregulatory">
                <span
                  className={`font-medium ml-6 ${
                    url === "/reports/criticalregulatory"
                      ? "text-white"
                      : "text-black"
                  }`}
                  style={{ fontSize: "16px" }}
                >
                  Regulatory
                </span>
              </Link>
            </span>
            <span
              className={`flex items-center sec-c ${
                url === "/reports/noncritical" ? "active" : ""
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-card-checklist"
                viewBox="0 0 16 16"
              >
                <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z" />
                <path d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0M7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0" />
              </svg>
              <Link to="/reports/noncritical">
                <span
                  className={`font-medium ml-6 ${
                    url === "/reports/noncritical" ? "text-white" : "text-black"
                  }`}
                  style={{ fontSize: "16px" }}
                >
                  Non Critical
                </span>
              </Link>
            </span>
          </div>
        )}
      </div>
      <span
        className={`flex items-center sec-c mt-2 ${
          url === "/reports/agent-scorecard" ? "active" : ""
        }`}
      >
        <Link to="/reports/agent-scorecard">
          <i
            className="fa fa-superpowers"
            aria-hidden="true"
            style={{
              color: url === "/reports/agent-scorecard" ? "white" : "black",
            }}
          ></i>
          <span
            className={`font-medium ml-6 ${
              url === "/reports/agent-scorecard" ? "text-white" : "text-black"
            }`}
            style={{ fontSize: "16px" }}
          >
            Agent Scorecard
          </span>
        </Link>
      </span>
    </div>
  );

  // Default Navigation
  const renderDefaultNav = () => (
    <ul>
      {usecase !== "Banking" &&
        usecase !== "Banking Collections" &&
        // usecase !== "Insurance" &&
        usecase !== "Banking Telesales" && (
          <li className={url === "/reports/reports-dashboard" ? "active" : ""}>
            <Link to="/reports/reports-dashboard">
              <i className="fa fa-snowflake-o" aria-hidden="true"></i>
              <a style={{ fontSize: "14px" }}>Report</a>
            </Link>
          </li>
        )}

      <li className={url === "/reports/service-request" ? "active" : ""}>
        <Link to="/reports/service-request">
          <i className="fa fa-superpowers" aria-hidden="true"></i>
          <a style={{ fontSize: "14px" }}>Service Request</a>
        </Link>
      </li>

      <li className={url === "/reports/agent-scorecard" ? "active" : ""}>
        <Link to="/reports/agent-scorecard">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-journal-text"
            viewBox="0 0 16 16"
          >
            <path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5" />
            <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" />
            <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" />
          </svg>
          <a style={{ fontSize: "14px" }}>Agent Scorecard</a>
        </Link>
      </li>

      <li className={url === "/reports/customer-intent-all" ? "active" : ""}>
        <Link to="/reports/customer-intent-all">
          <i className="fa fa-tachometer" aria-hidden="true"></i>
          <a style={{ fontSize: "14px" }}>Customer Intent</a>
        </Link>
      </li>
      <li className={url === "/reports/product-intent-all" ? "active" : ""}>
        <Link to="/reports/product-intent-all">
          <i className="flaticon-analytics"></i>
          <a style={{ fontSize: "14px" }}>Product by Intent</a>
        </Link>
      </li>
      <li className={url === "/reports/cx-score-trend-all" ? "active" : ""}>
        <Link to="/reports/cx-score-trend-all">
          <i className="fa fa-line-chart" aria-hidden="true"></i>
          <a style={{ fontSize: "14px" }}>CX Score Trend</a>
        </Link>
      </li>
      <li className={url === "/reports/manager-review" ? "active" : ""}>
        <Link to="/reports/manager-review">
          <i className="fa fa-comment" aria-hidden="true"></i>
          <a style={{ fontSize: "14px" }}>Manager Review</a>
        </Link>
      </li>
      <li className={url === "/reports/opportunity" ? "active" : ""}>
        <Link to="/reports/opportunity">
          <i className="fa fa-snowflake-o" aria-hidden="true"></i>
          {usecase === "Third Party Collection Agency" ? (
            <a style={{ fontSize: "14px" }}>Promise To Pay</a>
          ) : (
            <a style={{ fontSize: "14px" }}>Opportunities</a>
          )}
        </Link>
      </li>
      {collectionModule && (
        <li className={url === "/reports/collection" ? "active" : ""}>
          <Link to="/reports/collection">
            <span className="flex items-center">
              <BsCollection />
              <a style={{ fontSize: "14px" }}>Collection</a>
            </span>
          </Link>
        </li>
      )}
      {collectionModule && (
        <li className={url === "/reports/performance" ? "active" : ""}>
          <Link to="/reports/performance">
            <span className="flex items-center">
              <VscActivateBreakpoints />
              <a style={{ fontSize: "14px" }}>Performance</a>
            </span>
          </Link>
        </li>
      )}
      {stockBrokingModule && (
        <li className={url === "/reports/compliance" ? "active" : ""}>
          <Link to="/reports/compliance">
            <VscActivateBreakpoints />
            <a style={{ fontSize: "14px" }}>Compliance</a>
          </Link>
        </li>
      )}
    </ul>
  );

  // Banking Collections PCVC Section
  const isAgentRole =
    role === "Agent" || role === "Agenth" || role.includes("Agent");

  const renderBankingCollectionsPCVC = () => (
    <div
      className={`side-panel`}
      style={{
        height: url === "/reports/dashboard" ? "666px" : "",
        width: "320px",
      }}
    >
      <nav className="secondary-menu marker:bg-none">
        {isAgentRole ? (
          <ul>
            <li className={url === "/reports/agent-scorecard" ? "active" : ""}>
              <Link to="/reports/agent-scorecard">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-journal-text"
                  viewBox="0 0 16 16"
                >
                  <path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5" />
                  <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" />
                  <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" />
                </svg>
                <a style={{ fontSize: "14px" }}>Agent Scorecard</a>
              </Link>
            </li>
            <div
              className={`flex items-center text-black hover:bg-blue-900 hover:text-white px-9 py-8 rounded-tr-full rounded-br-full my-report cursor-pointer ${
                url.includes("/my-reports") ||
                url.includes("/saved-reports-details")
                  ? "my-report-active rounded-tr-full rounded-br-full"
                  : ""
              }`}
              onClick={handleMyReportsClick}
            >
              <i className="fa fa-file" aria-hidden="true"></i>
              <span className="ml-10" style={{ fontSize: "15px" }}>
                My Reports
              </span>
            </div>
            <li
              className={`relative text-center cursor-pointer mb-4 hover-effect ${url === "/reports" || isStandardReportActive ? "active" : ""}`}
            >
              <Link to="/reports" className="flex items-center">
                <i
                  className="fa fa-snowflake-o text-icon"
                  aria-hidden="true"
                ></i>
                <a className="text-link" style={{ fontSize: "14px" }}>
                  Collection Report
                </a>
              </Link>
              <img
                src={
                  url === "/reports" || isStandardReportActive
                    ? arrowdown
                    : arrowdownblack
                }
                alt="arrow"
                className={`absolute h-14 w-14 arrow-icon ${
                  standardReportDrop ? "transform rotate-180" : ""
                }`}
                style={{
                  right: "20px",
                  bottom: "16px",
                  height: "30px",
                  width: "30px",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setStandardReportDrop(!standardReportDrop);
                }}
              />
            </li>
            {standardReportDrop && (
              <ul style={{ marginLeft: "20px" }}>
                <li className={url === "/reports/predue" ? "active" : ""}>
                  <Link to="/reports/predue">
                    <i className="fa fa-money" aria-hidden="true"></i>
                    <a
                      style={{ fontSize: "14px" }}
                      className="whitespace-nowrap"
                    >
                      Pre-Due Collection
                    </a>
                  </Link>
                </li>{" "}
                <li
                  className={url === "/reports/postless" ? "active" : ""}
                  style={{ marginTop: "10px" }}
                >
                  <Link to="/reports/postless">
                    <i className="fa fa-money" aria-hidden="true"></i>
                    <a style={{ fontSize: "14px" }}>
                      Post-Due Collections &lt; 30 Days
                    </a>
                  </Link>
                </li>
                <li
                  className={url === "/reports/postgreater" ? "active" : ""}
                  style={{ marginTop: "10px" }}
                >
                  <Link to="/reports/postgreater">
                    <i className="fa fa-money" aria-hidden="true"></i>
                    <a style={{ fontSize: "14px" }}>
                      Post-Due Collection &gt; 30 Days
                    </a>
                  </Link>
                </li>
                <li
                  className={url === "/reports/latedue" ? "active" : ""}
                  style={{ marginTop: "10px" }}
                >
                  <Link to="/reports/latedue">
                    <i className="fa fa-money" aria-hidden="true"></i>
                    <a style={{ fontSize: "14px" }}>
                      Late Collections &gt; 60 Days
                    </a>
                  </Link>
                </li>
              </ul>
            )}

            {/* <li
              className={`
                ${url.includes("/reports/collection-strategy") ? "active" : ""}
                relative text-center cursor-pointer mb-4 hover-effect
              `}
            >
              <div
                className={`flex items-center text-black hover:bg-blue-900 hover:text-white px-9 py-8 rounded-tr-full rounded-br-full my-report cursor-pointer ${
                  url.includes("/reports/collection-strategy")
                    ? "my-report-active rounded-tr-full rounded-br-full"
                    : ""
                }`}
                onClick={handleCollectionStrategy}
              >
                <i className="fa fa-tachometer" aria-hidden="true"></i>
                <span className="ml-10" style={{ fontSize: "15px" }}>
                  Collection Strategy
                </span>
              </div>
            </li> */}

            {storage.getItem("username") !== "MYABCNG01" &&
              storage.getItem("username") !== "GNLNNT01" && (
                <li
                  className={`
                    ${url.includes("/reports/transcription-report") ? "active" : ""}
                    relative text-center cursor-pointer mb-4 hover-effect
                  `}
                >
                  <div
                    className={`flex items-center text-black hover:bg-blue-900 hover:text-white px-9 py-8 rounded-tr-full rounded-br-full my-report cursor-pointer ${
                      url.includes("/reports/transcription-report")
                        ? "my-report-active rounded-tr-full rounded-br-full"
                        : ""
                    }`}
                    onClick={handleTranscriptionAudit}
                  >
                    <i className="fa fa-tachometer" aria-hidden="true"></i>
                    <span className="ml-10" style={{ fontSize: "15px" }}>
                      Transcription Audit
                    </span>
                  </div>
                </li>
              )}

            <li className={url === "/reports/service-request" ? "active" : ""}>
              <Link to="/reports/service-request">
                <i className="fa fa-superpowers" aria-hidden="true"></i>
                <a style={{ fontSize: "14px" }}>Service Request</a>
              </Link>
            </li>

            <li
              className={`
                ${
                  url === "/reports/customer-intent" ||
                  url === "/reports/product-intent" ||
                  url === "/reports/ptp"
                    ? "active"
                    : ""
                }
                relative text-center cursor-pointer mb-4 hover-effect
              `}
            >
              <Link to="/reports/customer-intent" className="flex items-center">
                <i
                  className="fa fa-tachometer text-icon"
                  aria-hidden="true"
                ></i>
                <a className="text-link" style={{ fontSize: "14px" }}>
                  Intent Report
                </a>
                <img
                  src={
                    url === "/reports/customer-intent" ||
                    url === "/reports/product-intent" ||
                    url === "/reports/ptp"
                      ? arrowdown
                      : arrowdownblack
                  }
                  alt="arrow"
                  className={`absolute arrow-icon ${
                    intentDrop ? "transform rotate-180" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIntentDrop(!intentDrop);
                  }}
                  style={{
                    right: "20px",
                    bottom: "16px",
                    height: "30px",
                    width: "30px",
                  }}
                />
              </Link>
            </li>
            {intentDrop && (
              <ul
                style={{ marginLeft: "20px", transition: "ease-in" }}
                className="mt-2 mb-4"
              >
                <li
                  className={url === "/reports/customer-intent" ? "active" : ""}
                >
                  <Link to="/reports/customer-intent">
                    <i className="fa fa-tachometer" aria-hidden="true"></i>
                    <a style={{ fontSize: "14px" }}>Collection Intent</a>
                  </Link>
                </li>
                <li
                  className={url === "/reports/product-intent" ? "active" : ""}
                  style={{ marginTop: "10px" }}
                >
                  <Link to="/reports/product-intent">
                    <i className="flaticon-analytics"></i>
                    <a style={{ fontSize: "14px" }}>Product by Intent</a>
                  </Link>
                </li>
                <li className={url === "/reports/ptp" ? "active" : ""}>
                  <Link to="/reports/ptp">
                    <i className="fa fa-snowflake-o" aria-hidden="true"></i>
                    <a style={{ fontSize: "14px" }}>Promise To Pay</a>
                  </Link>
                </li>
              </ul>
            )}
            <li className={url === "/reports/cx-score-trend" ? "active" : ""}>
              <Link to="/reports/cx-score-trend">
                <i className="fa fa-line-chart" aria-hidden="true"></i>
                <a style={{ fontSize: "14px" }}>Collection Score Trends</a>
              </Link>
            </li>
            <li className={url === "/reports/manager-review" ? "active" : ""}>
              <Link to="/reports/manager-review">
                <i className="fa fa-comment" aria-hidden="true"></i>
                <a style={{ fontSize: "14px" }}>Manager Review</a>
              </Link>
            </li>
            <li
              className={url === "/reports/deviance-analysis" ? "active" : ""}
            >
              <Link to="/reports/deviance-analysis">
                <span className="flex items-center">
                  <VscActivateBreakpoints />
                  <a style={{ fontSize: "14px" }}>Deviance Analysis</a>
                </span>
              </Link>
            </li>
            {collectionModule && (
              <li className={url === "/reports/collection" ? "active" : ""}>
                <Link to="/reports/collection">
                  <span className="flex items-center">
                    <BsCollection />
                    <a style={{ fontSize: "14px" }}>Collection</a>
                  </span>
                </Link>
              </li>
            )}
            {collectionModule && (
              <li className={url === "/reports/performance" ? "active" : ""}>
                <Link to="/reports/performance">
                  <span className="flex items-center">
                    <VscActivateBreakpoints />
                    <a style={{ fontSize: "14px" }}>Performance</a>
                  </span>
                </Link>
              </li>
            )}
            {stockBrokingModule && (
              <li className={url === "/reports/compliance" ? "active" : ""}>
                <Link to="/reports/compliance">
                  <VscActivateBreakpoints />
                  <a style={{ fontSize: "14px" }}>Compliance</a>
                </Link>
              </li>
            )}
          </ul>
        ) : (
          <ul>
            <li
              className={`
                ${
                  url === "/reports" ||
                  url === "/reports/my-reports" ||
                  isStandardReportActive
                    ? "active"
                    : ""
                }
                relative text-center cursor-pointer mb-4 hover-effect
              `}
            >
              <div
                className={`flex items-center text-black hover:bg-blue-900 hover:text-white px-9 py-8 rounded-tr-full rounded-br-full my-report cursor-pointer ${
                  url.includes("/my-reports") ||
                  url.includes("/saved-reports-details")
                    ? "my-report-active rounded-tr-full rounded-br-full"
                    : ""
                }`}
                onClick={handleMyReportsClick}
              >
                <i className="fa fa-file" aria-hidden="true"></i>
                <span className="ml-10" style={{ fontSize: "15px" }}>
                  My Reports
                </span>
              </div>
            </li>

            <li
              className={`relative text-center cursor-pointer mb-4 hover-effect ${url === "/reports" || isStandardReportActive ? "active" : ""} `}
            >
              <Link to="/reports" className="flex items-center">
                <i
                  className="fa fa-snowflake-o text-icon"
                  aria-hidden="true"
                ></i>
                <a className="text-link" style={{ fontSize: "14px" }}>
                  Collection Reports
                </a>
              </Link>
              <img
                src={
                  url === "/reports" || isStandardReportActive
                    ? arrowdown
                    : arrowdownblack
                }
                alt="arrow"
                className={`absolute h-14 w-14 arrow-icon ${
                  standardReportDrop ? "transform rotate-180" : ""
                }`}
                style={{
                  right: "20px",
                  bottom: "16px",
                  height: "30px",
                  width: "30px",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setStandardReportDrop(!standardReportDrop);
                }}
              />
            </li>
            {standardReportDrop && (
              <ul style={{ marginLeft: "20px" }}>
                <li className={url === "/reports/predue" ? "active" : ""}>
                  <Link to="/reports/predue">
                    <i className="fa fa-money" aria-hidden="true"></i>
                    <a
                      style={{ fontSize: "14px" }}
                      className="whitespace-nowrap"
                    >
                      Pre-Due Collection
                    </a>
                  </Link>
                </li>
                <li
                  className={url === "/reports/postless" ? "active" : ""}
                  style={{ marginTop: "10px" }}
                >
                  <Link to="/reports/postless">
                    <i className="fa fa-money" aria-hidden="true"></i>
                    <a style={{ fontSize: "14px" }}>
                      Post-Due Collections &lt; 30 Days
                    </a>
                  </Link>
                </li>
                <li
                  className={url === "/reports/postgreater" ? "active" : ""}
                  style={{ marginTop: "10px" }}
                >
                  <Link to="/reports/postgreater">
                    <i className="fa fa-money" aria-hidden="true"></i>
                    <a style={{ fontSize: "14px" }}>
                      Post-Due Collection &gt; 30 Days
                    </a>
                  </Link>
                </li>

                <li
                  className={url === "/reports/latedue" ? "active" : ""}
                  style={{ marginTop: "10px" }}
                >
                  <Link to="/reports/latedue">
                    <i className="fa fa-money" aria-hidden="true"></i>
                    <a style={{ fontSize: "14px" }}>
                      Late Collections &gt; 60 Days
                    </a>
                  </Link>
                </li>
              </ul>
            )}

            {!storage.getItem("role").includes("DCA") && (
              <li
                className={`
                ${url.includes("/reports/collection-strategy") ? "active" : ""}
                relative text-center cursor-pointer mb-4 hover-effect
              `}
              >
                <div
                  className={`flex items-center text-black hover:bg-blue-900 hover:text-white px-9 py-8 rounded-tr-full rounded-br-full my-report cursor-pointer ${
                    url.includes("/reports/collection-strategy")
                      ? "my-report-active rounded-tr-full rounded-br-full"
                      : ""
                  }`}
                  onClick={handleCollectionStrategy}
                >
                  <i className="fa fa-tachometer" aria-hidden="true"></i>
                  <span className="ml-10" style={{ fontSize: "15px" }}>
                    Collection Strategy
                  </span>
                </div>
              </li>
            )}

            {storage.getItem("username") !== "MYABCNG01" &&
              storage.getItem("username") !== "GNLNNT01" && (
                <li
                  className={`
                    ${url.includes("/reports/transcription-report") ? "active" : ""}
                    relative text-center cursor-pointer mb-4 hover-effect
                  `}
                >
                  <div
                    className={`flex items-center text-black hover:bg-blue-900 hover:text-white px-9 py-8 rounded-tr-full rounded-br-full my-report cursor-pointer ${
                      url.includes("/reports/transcription-report")
                        ? "my-report-active rounded-tr-full rounded-br-full"
                        : ""
                    }`}
                    onClick={handleTranscriptionAudit}
                  >
                    <i className="fa fa-tachometer" aria-hidden="true"></i>
                    <span className="ml-10" style={{ fontSize: "15px" }}>
                      Transcription Audit
                    </span>
                  </div>
                </li>
              )}
            <li className={url === "/reports/agent-scorecard" ? "active" : ""}>
              <Link to="/reports/agent-scorecard">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-journal-text"
                  viewBox="0 0 16 16"
                >
                  <path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5" />
                  <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" />
                  <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" />
                </svg>
                <a style={{ fontSize: "14px" }}>Agent Scorecard</a>
              </Link>
            </li>
            <li
              className={url === "/reports/deviance-analysis" ? "active" : ""}
            >
              <Link to="/reports/deviance-analysis">
                <span className="flex items-center">
                  <VscActivateBreakpoints />
                  <a style={{ fontSize: "14px" }}>Deviance Analysis</a>
                </span>
              </Link>
            </li>

            <li className={url === "/reports/customer-intent" ? "active" : ""}>
              <Link to="/reports/customer-intent">
                <i className="fa fa-tachometer" aria-hidden="true"></i>
                <a style={{ fontSize: "14px" }}>Customer Intent</a>
              </Link>
            </li>

            <li className={url === "/reports/product-intent" ? "active" : ""}>
              <Link to="/reports/product-intent">
                <i className="flaticon-analytics"></i>
                <a style={{ fontSize: "14px" }}>Product by Intent</a>
              </Link>
            </li>

            <li className={url === "/reports/ptp" ? "active" : ""}>
              <Link to="/reports/ptp">
                <i className="fa fa-snowflake-o" aria-hidden="true"></i>
                <a style={{ fontSize: "14px" }}>Promise To Pay</a>
              </Link>
            </li>

            <li className={url === "/reports/collection" ? "active" : ""}>
              <Link to="/reports/collection">
                <span className="flex items-center">
                  <BsCollection />
                  <a style={{ fontSize: "14px" }}>Collection</a>
                </span>
              </Link>
            </li>

            <li className={url === "/reports/performance" ? "active" : ""}>
              <Link to="/reports/performance">
                <span className="flex items-center">
                  <VscActivateBreakpoints />
                  <a style={{ fontSize: "14px" }}>Performance</a>
                </span>
              </Link>
            </li>
          </ul>
        )}
      </nav>
    </div>
  );

  // insurance

  // SP Madrid, Maya Bank Collections, UNO Bank Collections Section
  const renderSPMadridOrMaya = () => (
    <div
      className={`side-panel`}
      style={{ height: url === "/reports/dashboard" ? "666px" : "" }}
    >
      <nav className="secondary-menu marker:bg-none">
        <ul>
          <li className={url === "/reports/promise-to-pay" ? "active" : ""}>
            <Link to="/reports/promise-to-pay">
              <i className="fa fa-snowflake-o" aria-hidden="true"></i>
              <a style={{ fontSize: "14px" }}>Promise To Pay</a>
            </Link>
          </li>
          <li className={url === "/reports/collection" ? "active" : ""}>
            <Link to="/reports/collection">
              <span className="flex items-center">
                <BsCollection />
                <a style={{ fontSize: "14px" }}>Collection</a>
              </span>
            </Link>
          </li>
          {role === "Master" && (
            <li className={url === "/reports/agent-scorecard" ? "active" : ""}>
              <Link to="/reports/agent-scorecard">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-journal-text"
                  viewBox="0 0 16 16"
                >
                  <path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5" />
                  <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" />
                  <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" />
                </svg>
                <a style={{ fontSize: "14px" }}>Agent Scorecard</a>
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );

  return (
    <>
      {client !== "SP Madrid" &&
      client !== "Maya Bank Collections" &&
      !client.includes("Collections") ? (
        <div
          className={`side-panel`}
          // style={{ height: url === "/reports/dashboard" ? "666px" : "" }}
          style={{
            height: url === "/reports/dashboard" ? "666px" : "",
            width: "320px",
          }}
        >
          <nav className="secondary-menu">
            {client === "DBS Bank Singapore" && renderTradeSection()}
            {usecase === "Complaints Management" &&
              renderComplaintsManagement()}
            {usecase === "Insurance - PCVC Verification" &&
              renderInsurancePCVC()}

            {usecase !== "Complaints Management" &&
              usecase !== "Insurance - PCVC Verification" &&
              client !== "DBS Bank Singapore" &&
              renderDefaultNav()}
          </nav>
        </div>
      ) : usecase.includes("Collections") ? (
        renderBankingCollectionsPCVC()
      ) : (
        renderSPMadridOrMaya()
      )}
    </>
  );
};

export default ReportNav;
